import { Alert, AnimatedContentLoader } from '@root/components'
import { useVerohallintoCertificateStatus } from '@root/query/hooks'
import { Trans, useTranslation } from 'react-i18next'

const VerohallintoSettingsAlert: React.FC = () => {
  const [t] = useTranslation()

  const { data, isLoading } = useVerohallintoCertificateStatus()

  const renderAlert = () => {
    if (!data) {
      return null
    }

    if (data.has_encountered_error_in_fetching) {
      return (
        <Alert
          title={t('settings.verohallintoSettings.alertError.title')}
          description={
            <Trans
              i18nKey="settings.verohallintoSettings.alertError.description"
              components={[
                <a
                  key="link"
                  href={t('link.docs.suomiauthorization')}
                  target="_blank"
                  rel="noopener noreferrer"
                ></a>
              ]}
            />
          }
          type="error"
        ></Alert>
      )
    }

    if (!data.has_certificate && !data.is_fetching) {
      return (
        <Alert
          title={t('settings.verohallintoSettings.alertMissing.title')}
          description={
            <Trans
              i18nKey="settings.verohallintoSettings.alertMissing.description"
              components={[
                <a
                  key="link"
                  href={t('link.docs.suomiauthorization')}
                  target="_blank"
                  rel="noopener noreferrer"
                ></a>
              ]}
            />
          }
          type="info"
        ></Alert>
      )
    }

    if (data.is_fetching) {
      return (
        <Alert
          title={t('settings.verohallintoSettings.alertFetching.title')}
          description={
            <Trans
              i18nKey="settings.verohallintoSettings.alertFetching.description"
              components={[
                <a
                  key="link"
                  href={t('link.docs.suomiauthorization')}
                  target="_blank"
                  rel="noopener noreferrer"
                ></a>
              ]}
            />
          }
          type="warning"
        ></Alert>
      )
    }

    if (data.has_certificate && !data.is_fetching) {
      return (
        <Alert
          title={t('settings.verohallintoSettings.alertSuccess.title')}
          description={
            <Trans
              i18nKey="settings.verohallintoSettings.alertSuccess.description"
              components={[
                <a
                  key="link"
                  href={t('link.docs.suomiauthorization')}
                  target="_blank"
                  rel="noopener noreferrer"
                ></a>
              ]}
            />
          }
          type="success"
        ></Alert>
      )
    }

    return null
  }

  return (
    <AnimatedContentLoader isLoading={isLoading}>
      <>{renderAlert()}</>
    </AnimatedContentLoader>
  )
}

export default VerohallintoSettingsAlert
